import { AssetSubClassCode, Entity, PrimaryMethod, SnakeMeta } from '@api';

export const isEntity = (input: unknown): input is Entity => {
  return (
    input !== null &&
    typeof input === 'object' &&
    'primary_method' in input &&
    input.primary_method !== undefined
  );
};

export const isSinglePriceEntity = (entity: Entity): boolean => {
  return (
    isEntity(entity) &&
    (entity.primary_method !== PrimaryMethod.Price ||
      entity.sub_class === AssetSubClassCode.FxCrypto ||
      !isPriceSnake(entity.default_snake))
  );
};

export const isPriceSnake = (snake: string) => /\.price$/.test(snake);
export const isYieldSnake = (snake: string) => snake.endsWith('.yield');

export const isSnakeWithThreshold = (snakeMeta?: SnakeMeta) =>
  !!snakeMeta?.threshold;

export const getEntityName = (entity: Entity, snakeMeta: SnakeMeta) => {
  return isPriceSnake(entity.default_snake)
    ? entity.name
    : `${entity.name} | ${snakeMeta.name.english}`;
};

export const hasKeyValues = (entityTag: string) =>
  !['btcusd', 'ethusd', 'ltcusd'].includes(entityTag);

/**
 * Extracts entity tag from a snake.
 */
export const getEntityTagFromSnake = (snake: string) => {
  const dotIndex = snake.indexOf('.');
  return dotIndex === -1 ? snake : snake.split('.')[0];
};
/**
 * Extracts tickers from a snake array.
 */
export const getTickersFromSnakes = (snakes: string[]) => {
  if (!snakes.length) {
    return [];
  }

  return snakes.map(snake => snake.split('_')[0].toUpperCase());
};

export const formatEntityTag = (entityTag?: string) => {
  if (!entityTag) {
    return undefined;
  }

  const [ticker, exchange] = entityTag.split('_');

  if (!ticker) {
    return undefined;
  }

  if (!exchange) {
    return ticker.toUpperCase();
  }

  return `${ticker.toUpperCase()}:${exchange.toUpperCase()}`;
};
